import { Icon } from '@eventr/common-storybook'
import { useEditSectionContext } from '../../feat/editItinerary/editSectionProvider'

interface ISubItemEditButton {
    data: any
    renderOptions: any
}

export const SubItemEditButton = ({
    data,
    renderOptions,
}: ISubItemEditButton) => {
    const { section } = useEditSectionContext()

    return (
        <Icon
            name="Chevron_Right"
            onClick={() => {
                window.pushPath(
                    '/edit/Section/' +
                    section?.id +
                    '/' +
                    data._id +
                    '/' +
                    renderOptions.pageId
                )
            }}
        />
    )
}
